var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"h-auto",attrs:{"width":"200","src":"https://i.imgur.com/hbNZZ4T.png","alt":"Logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }